import { Button, Tabs } from 'antd';
import React, { useEffect, useState } from 'react';
import { Col, Row } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import clienteAxios from '../../../configAxios/configAxios';
import { errorSwal } from '../../../helper/swalHelpers';

const { TabPane } = Tabs;
const Noticias = ({ modulo }) => {
    const [noticias, setNoticias] = useState([])


    useEffect(() => {
        const fetchNoticias = async () => {
            try {
                let response = await clienteAxios.get(`BuscarArticuloActivo/${modulo}`);
                if (response.status === 200) {
                    let data = response.data.data;
                    setNoticias(data);
                }

            } catch (error) {
                errorSwal("Ocurrió un error", "Vuelve a intentarlo", "Refrescar pagina");
            }
        }
        fetchNoticias();
    }, [])

    return (
        <Row>
            <Col xs={12} className="px-0">
                <Tabs className="tab-hyundai" centered>
                    {noticias && noticias.length > 0 && noticias.map((seccion) =>
                        <TabPane tab={<h5 className="bold-title-hyundai px-1 px-md-4 px-lg-5 f-responsive">{seccion.Categoria}</h5>} key={seccion.Categoria}>
                            <Seccion articulos={seccion.articulos} modulo={modulo} />
                        </TabPane>
                    )}
                </Tabs>
            </Col>
        </Row>
    );
};

const Seccion = ({ articulos, modulo }) => {
    if (articulos.length < 1) return null;


    return (
        <>
            {articulos && articulos.map((articulo, i) =>
                <React.Fragment key={i} >
                    <Row className="d-none d-md-flex">
                        <Col md={6} className="my-5">
                            <img src={articulo.Imagen} className="img-fluid img-destacadas" alt={articulo.Titulo} />
                        </Col>
                        <Col md={5} lg={4} className=" my-auto mx-auto">
                            <h5 className="bold-text-hyundai mb-1 mt-3 ">{articulo.Titulo}</h5>
                            <Fecha date={articulo.Fecha} />
                            <p className="parrafo-hyundai mb-5 hyundai-truncate" dangerouslySetInnerHTML={{ __html: articulo.Contenido }}></p>
                            <Link to={modulo === 'SERV_TECNICO' ? `/servicio-tecnico/campanas-y-recalls/${articulo.Slug}` : `/nosotros/noticias/${articulo.Slug}`}>
                                <Button className="mb-4 btn-secundario px-5">Ver Más</Button>
                            </Link>
                        </Col>
                    </Row>
                    <Row className="d-md-none" key={i}>
                        <Col md={12} className="text-center px-5 mt-4 mb-3 mx-auto">
                            <h5 className="bold-title-hyundai mb-1 mt-1 f-responsive">{articulo.Titulo}</h5>
                            <Fecha date={articulo.Fecha} />
                            <p className="parrafo-hyundai text-left px-2 f-responsive-10 hyundai-truncate" dangerouslySetInnerHTML={{ __html: articulo.Contenido }}></p>
                            <Link to={modulo === 'SERV_TECNICO' ? `/servicio-tecnico/campanas-y-recalls/${articulo.Slug}` : `/nosotros/noticias/${articulo.Slug}`}>
                                <Button className="mb-2 mt-3 btn-secundario px-4 font-btn" >Ver Más</Button>
                            </Link>
                        </Col>
                        <Col xs={12} className="mb-3">
                            <img src={articulo.Imagen} className="img-fluid img-destacadas" alt={articulo.Titulo} />
                        </Col>
                    </Row>
                </React.Fragment>
            )}
        </>
    )
}

const Fecha = ({ date }) => {
    let fecha = date ? new Date(date) : new Date();
    return (
        <h6 className="bold-title-hyundai f-responsive">{fecha.toLocaleDateString('es-CL', {timeZone: 'UTC'})}</h6>
    )
}

export default Noticias;